module.exports = __webpack_public_path__ + "static/media/19ESCAP47.f94aa115.jpg";